import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChannelService } from 'src/app/top-bar/service/channel.service';
import { convertMessageToPredefined, convertPredefinedToMessage, defaultMessage, getNameByIcon } from 'src/app/top-bar/util/message-util';
import { ChatMessage } from '../../../model/chat-message';
import { PredefinedMessage } from '../../../model/predefined-message';
import { ChatService } from '../../../service/chat.service';
import { PredefinedMessageFormComponent } from '../predefined-message-form/predefined-message-form.component';

@Component({
  selector: 'app-message-window',
  templateUrl: './message-window.component.html',
  styleUrls: ['./message-window.component.scss']
})
export class MessageWindowComponent implements OnInit {

  message: ChatMessage;
  predefinedMessages: PredefinedMessage[] = [];

  @Output() messageConfirmed: EventEmitter<ChatMessage> = new EventEmitter();

  constructor(private dialog: MatDialog, private chatService: ChatService, public channelService: ChannelService) {
    this.message = defaultMessage();
  }

  ngOnInit(): void {
    this.fetchPredefined();
  }

  setContent(event: InputEvent): void {
    this.message.message = (event.target as HTMLTextAreaElement).value;
  }

  confirmMessage(): void {
    this.messageConfirmed.emit(this.message);
    this.message = defaultMessage();
  }

  saveMessage(): void {
    const messageToSave: PredefinedMessage = this.predefinedMessages.find(pred => pred.message === this.message.message);
    this.dialog.open(PredefinedMessageFormComponent, {
      data: messageToSave ? messageToSave : convertMessageToPredefined(this.message),
      minWidth: '30vmin',
      minHeight: '30vmin',
      maxWidth: '100vmin',
      maxHeight: '100vmin'
    }).afterClosed().subscribe({
      next: isSave => {
        if (isSave)
          this.fetchPredefined();
      }
    });
  }

  select(message: PredefinedMessage): void {
    this.message = convertPredefinedToMessage(message);
  }

  deleteMessage(message: PredefinedMessage): void {
    this.chatService.deletePredefinedMessage(message).subscribe({
      next: () => {
        this.fetchPredefined();
        this.message = defaultMessage();
      }
    });
  }

  getClass(icon: string): string {
    return getNameByIcon(icon) || '';
  }

  getIcon(icon: string): string {
    return getNameByIcon(icon) ? icon : 'file_image';
  }

  private fetchPredefined(): void {
    this.chatService.fetchPredefinedMessages().subscribe(data => {
      this.predefinedMessages = data;
    });
  }

}
